import { useApiGet } from '../../../../services/tanstackApiService';

// ----------------------
// Types for pharmacy invoice logs
// ----------------------

export interface PharmacyPatientInfo {
  patient_id: number;
  patient_name: string;
  patient_mrn: string;
  age: number;
  gender: string;
  mobile_number: string;
  last_modified: string;
}

export interface PharmacyInvoiceLogItem {
  id: number;
  date: string;
  patient_name: string;
  patient_mrn: string;
  bill_no: string;
  invoice_no: string;
  date_of_invoice: string;
  total_amt: string;
  concession_amt: string;
  net_amt: string;
  net_amount: string;
  paid_amt: string;
  balance_amt: string;
  status: string;
  payment_status: string;
  bill_remark: string | null;
  no_of_item: number;
  referred_doctor: string;
}

export interface PharmacyInvoiceLogsMeta {
  limit: number;
  next: string | null;
  offset: number;
  previous: string | null;
  total_count: number;
}

export interface PharmacyInvoiceLogsResponse {
  status: boolean;
  message: string;
  data: {
    patient_info: PharmacyPatientInfo;
    invoices: PharmacyInvoiceLogItem[];
    meta: PharmacyInvoiceLogsMeta;
  };
}

export interface PharmacyInvoiceLogsFilters {
  patient_id?: number | null;
  limit?: number;
  offset?: number;
  search_query?: string;
}

export const pharmacyInvoiceLogsKey = (
  patientId: number | string | null,
  page: number,
  limit: number,
  search?: string,
) => ['pharmacy', 'invoices', 'logs', patientId ?? 0, { page, limit, search }] as const;

const pharmacyInvoiceLogsPath = (patientId: number | string) => 
  `pharmacy-invoice/patient-invoice-logs/${patientId}/`;

export interface UsePharmacyInvoiceLogsParams {
  patientId: number | string | null;
  page: number;
  limit: number;
  search?: string;
  enabled?: boolean;
}

export const usePharmacyInvoiceLogsQuery = ({
  patientId,
  page,
  limit,
  search,
  enabled = true,
}: UsePharmacyInvoiceLogsParams) => {
  const offset = (page - 1) * limit;

  return useApiGet<PharmacyInvoiceLogsResponse>(
    pharmacyInvoiceLogsKey(patientId, page, limit, search),
    {
      path: pharmacyInvoiceLogsPath(patientId as number | string),
      query: {
        limit,
        offset,
        search_query: search || undefined,
      },
    },
    {
      enabled: enabled && !!patientId,
      placeholderData: (previousData) => previousData,
    },
  );
};
